module.exports = __webpack_public_path__ + "static/media/match-icon.aafd9a9f.svg";